import type { BoPhan, BoPhanSuDungTSCD } from '@/types/schemas';
import type { DataTableColumn } from '@/components/custom/erp';

export const getDataTableColumns = (): DataTableColumn<BoPhanSuDungTSCD>[] => [
  {
    field: 'ma_bp',
    headerName: 'Mã bộ phận',
    width: 150
  },
  {
    field: 'ten_bp',
    headerName: 'Tên bộ phận',
    width: 250
  }
];

export const departmentSearchColumns: DataTableColumn<BoPhan>[] = [
  { field: 'ma_bp', headerName: 'Mã bộ phận', width: 150 },
  { field: 'ten_bp', headerName: 'Tên bộ phận', width: 250 },
  { field: 'uuid', headerName: 'UUID', width: 0, hide: true }
];
